import React, { useState, useEffect } from "react";
import '../../../assets/styles/Styles.css'
import { OneKlicksFileSDK } from "../../../SDK/OneKlicksFileSDK";
import { getSettings } from "../../../services/settingsService";
import ImageShow from "../../../Uitiles/ImageShow";

const SiteSettings = ({ settings, setSettings }) => {
    const [errors, setErrors] = useState({});
    const [isUploading, setIsUploading] = useState(false);
    const [logoPreview, setLogoPreview] = useState(null);
    const [faviconPreview, setFaviconPreview] = useState(null);
    const [authorSignaturePreview, setAuthorSignaturePreview] = useState(null);
    const [footerLogoPreview, setFooterLogoPreview] = useState(null);
    useEffect(() => {
        getSettings().then(settings => {
            setSettings(settings);
        });
    }, []);

    const validateField = (name, value) => {
        let error = '';
        switch (name) {
            case 'site_name':
                if (!value) error = 'Site name is required';
                else if (value.length < 2) error = 'Site name must be at least 2 characters';
                break;
            case 'site_description':
                if (!value) error = 'Site description is required';
                else if (value.length < 10) error = 'Site description must be at least 10 characters';
                break;
            case 'site_email':
                if (!value) error = 'Email is required';
                else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) error = 'Please enter a valid email address';
                break;
            case 'site_phone':
                if (!value) error = 'Phone number is required';
                else if (!/^\+?[1-9]\d{7,14}$/.test(value)) error = 'Please enter a valid phone number';
                break;
            case 'site_address':
                if (!value) error = 'Address is required';
                break;
            default:
                break;
        }
        return error;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const error = validateField(name, value);
        setErrors(prev => ({
            ...prev,
            [name]: error
        }));
        setSettings(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileChange = async (e, type) => {
        const file = e.target.files[0];
        if (file) {
            const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/x-icon'];
            if (!validTypes.includes(file.type)) {
                setErrors(prev => ({
                    ...prev,
                    [type]: 'Please upload a valid image file (JPEG, PNG, GIF, or ICO)'
                }));
                return;
            }

            setIsUploading(true);
            try {
                const root = "site/settings";
                const status = "public";
                const uploadResult = await OneKlicksFileSDK.uploadFile(root, status, file);
                
                if (!uploadResult || !uploadResult.fileId) {
                    throw new Error('Failed to upload file');
                }

                const reader = new FileReader();
                reader.onloadend = () => {
                    if (type === 'site_logo') {
                        setLogoPreview(reader.result);
                        setSettings(prev => ({
                            ...prev,
                            site_logo_url: uploadResult.file.root + "/" + uploadResult.file.fileName
                        }));
                    } else if (type === 'site_favicon') {
                        setFaviconPreview(reader.result);
                        setSettings(prev => ({
                            ...prev,
                            favicon_url: uploadResult.file.root + "/" + uploadResult.file.fileName
                        }));
                    } else if (type === 'site_footer_logo') {
                        setFooterLogoPreview(reader.result);
                        setSettings(prev => ({
                            ...prev,
                            footer_logo_url: uploadResult.file.root + "/" + uploadResult.file.fileName
                        }));
                    } else if (type === 'site_author_signature') {
                        setAuthorSignaturePreview(reader.result);
                        setSettings(prev => ({
                            ...prev,
                            author_signature_url: uploadResult.file.root + "/" + uploadResult.file.fileName
                        }));
                    }
                    
                    setSettings(prev => ({
                        ...prev,
                        [type]: uploadResult.fileId,
                        [`${type}_url`]: uploadResult.file.root + "/" + uploadResult.file.fileName
                    }));
                    
                    setErrors(prev => ({
                        ...prev,
                        [type]: ''
                    }));
                };
                reader.readAsDataURL(file);
            } catch (error) {
                console.error('Error uploading file:', error);
                setErrors(prev => ({
                    ...prev,
                    [type]: 'Failed to upload file. Please try again.'
                }));
            } finally {
                setIsUploading(false);
            }
        }
    };

    const handleRemoveImage = (type) => {
        if (type === 'site_logo') {
            setLogoPreview(null);
            setSettings(prev => ({
                ...prev,
                site_logo_url: null
            }));
        } else if (type === 'site_favicon') {
            setFaviconPreview(null);
            setSettings(prev => ({
                ...prev,
                favicon_url: null
            }));
        } else if (type === 'site_footer_logo') {
            setFooterLogoPreview(null);
            setSettings(prev => ({
                ...prev,
                footer_logo_url: null
            }));
        } else if (type === 'site_author_signature') {
            setAuthorSignaturePreview(null);
            setSettings(prev => ({
                ...prev,
                author_signature_url: null
            }));
        }
        
    };

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-personalskillshold tab-pane active fade show" id="dc-skills">
                <div className="dc-yourdetails dc-tabsinfo">
                    <div className="dc-tabscontenttitle">
                        <h3>Site Settings</h3>
                    </div>
                    <div className="dc-formtheme dc-userform">
                        <fieldset>
                            <div className="form-group">
                                <input 
                                    type="text" 
                                    name="site_name" 
                                    className={`form-control ${errors.site_name ? 'is-invalid' : ''}`}
                                    value={settings.site_name || ''} 
                                    placeholder="Site Name" 
                                    onChange={handleChange} 
                                />
                                {errors.site_name && <div className="invalid-feedback">{errors.site_name}</div>}
                            </div>
                            
                            <div className="form-group">
                                <textarea 
                                    name="site_description" 
                                    value={settings.site_description || ''} 
                                    onChange={handleChange} 
                                    className={`form-control ${errors.site_description ? 'is-invalid' : ''}`}
                                    placeholder="Site Description"
                                    rows="4"
                                ></textarea>
                                {errors.site_description && <div className="invalid-feedback">{errors.site_description}</div>}
                            </div>

                            <div className="form-group form-group-half">
                                <input 
                                    type="email" 
                                    name="site_email" 
                                    className={`form-control ${errors.site_email ? 'is-invalid' : ''}`}
                                    value={settings.site_email || ''} 
                                    placeholder="Contact Email" 
                                    onChange={handleChange} 
                                />
                                {errors.site_email && <div className="invalid-feedback">{errors.site_email}</div>}
                            </div>

                            <div className="form-group form-group-half">
                                <input 
                                    type="text" 
                                    name="site_phone" 
                                    className={`form-control ${errors.site_phone ? 'is-invalid' : ''}`}
                                    value={settings.site_phone || ''} 
                                    placeholder="Contact Phone" 
                                    onChange={handleChange} 
                                />
                                {errors.site_phone && <div className="invalid-feedback">{errors.site_phone}</div>}
                            </div>

                            <div className="form-group">
                                <textarea 
                                    name="site_address" 
                                    value={settings.site_address || ''} 
                                    onChange={handleChange} 
                                    className={`form-control ${errors.site_address ? 'is-invalid' : ''}`}
                                    placeholder="Site Address"
                                    rows="3"
                                ></textarea>
                                {errors.site_address && <div className="invalid-feedback">{errors.site_address}</div>}
                            </div>
                        </fieldset>
                    </div>
                </div>

                {/* Site Logo Upload */}
                <div className="dc-profilephoto dc-tabsinfo">
                    <div className="dc-tabscontenttitle">
                        <h3>Site Logo</h3>
                    </div>
                    <div className="dc-profilephotocontent">
                        <div className="dc-formtheme dc-formprojectinfo dc-formcategory">
                            <fieldset>
                                <div className="form-group form-group-label" style={{ position: 'relative' }}>
                                    <div className="dc-labelgroup" style={{ position: 'relative' }}>
                                        <label htmlFor="site-logo" className="dc-image-file">
                                            <span className={`ajax-load dc-btn ${errors.site_logo ? 'is-invalid' : ''}`}>Select Logo</span>
                                        </label>
                                        <span>Drop logo file here to upload</span>
                                        {isUploading && (
                                            <em className="dc-fileuploading">
                                                Uploading<i className="fa fa-spinner fa-spin"></i>
                                            </em>
                                        )}
                                    </div>
                                    <div className="moxie-shim moxie-shim-html5" style={{ position: 'absolute', top: 7, left: 11, width: 160, height: 42, overflow: 'hidden', zIndex: 0 }}>
                                        <input
                                            id="site-logo"
                                            type="file"
                                            style={{ fontSize: 999, opacity: 0, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                            accept="image/jpeg,.jpg,.jpeg,image/gif,.gif,image/png,.png"
                                            onChange={(e) => handleFileChange(e, 'site_logo')}
                                        />
                                    </div>
                                    {/* {errors.site_logo && <div className="invalid-feedback">{errors.site_logo}</div>} */}
                                </div>
                                {settings.site_logo_url && (
                                    <div className="form-group uploaded-placeholder">
                                        <ul className="dc-attachfile dc-attachfilevtwo">
                                            <li className="dc-uploadingholder dc-companyimg-user">
                                                <div className="dc-uploadingbox">
                                                    <figure>
                                                        
                                                        <ImageShow url={settings.site_logo_url} height={0} width={0} />
                                                        
                                                    </figure>
                                                    <div className="dc-uploadingbar">
                                                        <span className="uploadprogressbar"></span>
                                                        <span>Site Logo</span>
                                                        <em>
                                                            <a
                                                                href="#"
                                                                className="dc-remove-image lnr lnr-cross"
                                                                onClick={() => handleRemoveImage('site_logo')}
                                                            ></a>
                                                        </em>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                </div>

                {/* Site Footer Logo Upload */}
                <div className="dc-profilephoto dc-tabsinfo">
                    <div className="dc-tabscontenttitle">
                        <h3>Site Footer Logo</h3>
                    </div>
                    <div className="dc-profilephotocontent">
                        <div className="dc-formtheme dc-formprojectinfo dc-formcategory">
                            <fieldset>
                                <div className="form-group form-group-label" style={{ position: 'relative' }}>
                                    <div className="dc-labelgroup" style={{ position: 'relative' }}>
                                        <label htmlFor="site-footer-logo" className="dc-image-file">
                                            <span className={`ajax-load dc-btn ${errors.site_footer_logo ? 'is-invalid' : ''}`}>Select Logo</span>
                                        </label>
                                        <span>Drop logo file here to upload</span>
                                        {isUploading && (
                                            <em className="dc-fileuploading">
                                                Uploading<i className="fa fa-spinner fa-spin"></i>
                                            </em>
                                        )}
                                    </div>
                                    <div className="moxie-shim moxie-shim-html5" style={{ position: 'absolute', top: 7, left: 11, width: 160, height: 42, overflow: 'hidden', zIndex: 0 }}>
                                        <input
                                            id="site-footer-logo"
                                            type="file"
                                            style={{ fontSize: 999, opacity: 0, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                            accept="image/jpeg,.jpg,.jpeg,image/gif,.gif,image/png,.png"
                                            onChange={(e) => handleFileChange(e, 'site_footer_logo')}
                                        />
                                    </div>
                                    {/* {errors.site_logo && <div className="invalid-feedback">{errors.site_logo}</div>} */}
                                </div>
                                {settings.footer_logo_url && (
                                    <div className="form-group uploaded-placeholder">
                                        <ul className="dc-attachfile dc-attachfilevtwo">
                                            <li className="dc-uploadingholder dc-companyimg-user">
                                                <div className="dc-uploadingbox">
                                                    <figure>
                                                        
                                                        <ImageShow url={settings.footer_logo_url} height={0} width={0} />
                                                        
                                                    </figure>
                                                    <div className="dc-uploadingbar">
                                                        <span className="uploadprogressbar"></span>
                                                        <span>Site Footer Logo</span>
                                                        <em>
                                                            <a
                                                                href="#"
                                                                className="dc-remove-image lnr lnr-cross"
                                                                onClick={() => handleRemoveImage('site_footer_logo')}
                                                            ></a>
                                                        </em>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                </div>

                {/* Site Favicon Upload */}
                <div className="dc-profilephoto dc-tabsinfo">
                    <div className="dc-tabscontenttitle">
                        <h3>Site Favicon</h3>
                    </div>
                    <div className="dc-profilephotocontent">
                        <div className="dc-formtheme dc-formprojectinfo dc-formcategory">
                            <fieldset>
                                <div className="form-group form-group-label" style={{ position: 'relative' }}>
                                    <div className="dc-labelgroup" style={{ position: 'relative' }}>
                                        <label htmlFor="site-favicon" className="dc-image-file">
                                            <span className={`ajax-load dc-btn ${errors.site_favicon ? 'is-invalid' : ''}`}>Select Favicon</span>
                                        </label>
                                        <span>Drop favicon file here to upload (ICO, PNG, JPG)</span>
                                        {isUploading && (
                                            <em className="dc-fileuploading">
                                                Uploading<i className="fa fa-spinner fa-spin"></i>
                                            </em>
                                        )}
                                    </div>
                                    <div className="moxie-shim moxie-shim-html5" style={{ position: 'absolute', top: 7, left: 11, width: 160, height: 42, overflow: 'hidden', zIndex: 0 }}>
                                        <input
                                            id="site-favicon"
                                            type="file"
                                            style={{ fontSize: 999, opacity: 0, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                            accept="image/x-icon,.ico,image/png,.png,image/jpeg,.jpg"
                                            onChange={(e) => handleFileChange(e, 'site_favicon')}
                                        />
                                    </div>
                                    {errors.site_favicon && <div className="invalid-feedback">{errors.site_favicon}</div>}
                                </div>
                                {settings.favicon_url && (
                                    <div className="form-group uploaded-placeholder">
                                        <ul className="dc-attachfile dc-attachfilevtwo">
                                            <li className="dc-uploadingholder dc-companyimg-user">
                                                <div className="dc-uploadingbox">
                                                    <figure>
                                                        <ImageShow url={settings.favicon_url} height={0} width={0} />
                                                    </figure>
                                                    <div className="dc-uploadingbar">
                                                        <span className="uploadprogressbar"></span>
                                                        <span>Site Favicon</span>
                                                        <em>
                                                            <a
                                                                href="#"
                                                                className="dc-remove-image lnr lnr-cross"
                                                                onClick={() => handleRemoveImage('site_favicon')}
                                                            ></a>
                                                        </em>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                </div>

                {/* Site authOR signature Upload */}
                <div className="dc-profilephoto dc-tabsinfo">
                    <div className="dc-tabscontenttitle">
                        <h3>Site Author Signature</h3>
                    </div>
                    <div className="dc-profilephotocontent">
                        <div className="dc-formtheme dc-formprojectinfo dc-formcategory">
                            <fieldset>
                                <div className="form-group form-group-label" style={{ position: 'relative' }}>
                                    <div className="dc-labelgroup" style={{ position: 'relative' }}>
                                        <label htmlFor="site-favicon" className="dc-image-file">
                                            <span className={`ajax-load dc-btn ${errors.site_favicon ? 'is-invalid' : ''}`}>Select Author Signature</span>
                                        </label>
                                        <span>Drop author signature file here to upload (ICO, PNG, JPG)</span>
                                        {isUploading && (
                                            <em className="dc-fileuploading">
                                                Uploading<i className="fa fa-spinner fa-spin"></i>
                                            </em>
                                        )}
                                    </div>
                                    <div className="moxie-shim moxie-shim-html5" style={{ position: 'absolute', top: 7, left: 11, width: 160, height: 42, overflow: 'hidden', zIndex: 0 }}>
                                        <input
                                            id="site-author-signature"
                                            type="file"
                                            style={{ fontSize: 999, opacity: 0, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                            accept="image/x-icon,.ico,image/png,.png,image/jpeg,.jpg"
                                            onChange={(e) => handleFileChange(e, 'site_author_signature')}
                                        />
                                    </div>
                                    {errors.site_author_signature && <div className="invalid-feedback">{errors.site_author_signature}</div>}
                                </div>
                                {settings.author_signature_url && (
                                    <div className="form-group uploaded-placeholder">
                                        <ul className="dc-attachfile dc-attachfilevtwo">
                                            <li className="dc-uploadingholder dc-companyimg-user">
                                                <div className="dc-uploadingbox">
                                                    <figure>
                                                        <ImageShow url={settings.author_signature_url} height={0} width={0} />
                                                    </figure>
                                                    <div className="dc-uploadingbar">
                                                        <span className="uploadprogressbar"></span>
                                                        <span>Site Author Signature</span>
                                                        <em>
                                                            <a
                                                                href="#"
                                                                className="dc-remove-image lnr lnr-cross"
                                                                onClick={() => handleRemoveImage('site_author_signature')}
                                                            ></a>
                                                        </em>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                </div>

                {/* Additional Site Settings */}
                <div className="dc-tabsinfo">
                    <div className="dc-tabscontenttitle">
                        <h3>Additional Settings</h3>
                    </div>
                    <div className="dc-formtheme dc-userform">
                        <fieldset>
                            <div className="form-group form-group-half">
                                <select 
                                    name="site_currency" 
                                    className="form-control-select"
                                    value={settings.site_currency || 'USD'} 
                                    onChange={handleChange}
                                >
                                    <option value="">Select Currency</option>
                                    <option value="USD">USD - US Dollar</option>
                                    <option value="EUR">EUR - Euro</option>
                                    <option value="GBP">GBP - British Pound</option>
                                    <option value="INR">INR - Indian Rupee</option>
                                    <option value="CAD">CAD - Canadian Dollar</option>
                                    <option value="AUD">AUD - Australian Dollar</option>
                                    <option value="JPY">JPY - Japanese Yen</option>
                                    <option value="CNY">CNY - Chinese Yuan</option>
                                    <option value="CHF">CHF - Swiss Franc</option>
                                    <option value="SEK">SEK - Swedish Krona</option>
                                    <option value="NOK">NOK - Norwegian Krone</option>
                                    <option value="DKK">DKK - Danish Krone</option>
                                    <option value="PLN">PLN - Polish Zloty</option>
                                    <option value="CZK">CZK - Czech Koruna</option>
                                    <option value="HUF">HUF - Hungarian Forint</option>
                                    <option value="RUB">RUB - Russian Ruble</option>
                                    <option value="BRL">BRL - Brazilian Real</option>
                                    <option value="MXN">MXN - Mexican Peso</option>
                                    <option value="ZAR">ZAR - South African Rand</option>
                                    <option value="SGD">SGD - Singapore Dollar</option>
                                    <option value="HKD">HKD - Hong Kong Dollar</option>
                                    <option value="NZD">NZD - New Zealand Dollar</option>
                                    <option value="KRW">KRW - South Korean Won</option>
                                    <option value="THB">THB - Thai Baht</option>
                                    <option value="MYR">MYR - Malaysian Ringgit</option>
                                    <option value="PHP">PHP - Philippine Peso</option>
                                    <option value="IDR">IDR - Indonesian Rupiah</option>
                                    <option value="VND">VND - Vietnamese Dong</option>
                                    <option value="TRY">TRY - Turkish Lira</option>
                                    <option value="AED">AED - UAE Dirham</option>
                                    <option value="SAR">SAR - Saudi Riyal</option>
                                    <option value="EGP">EGP - Egyptian Pound</option>
                                    <option value="NGN">NGN - Nigerian Naira</option>
                                    <option value="KES">KES - Kenyan Shilling</option>
                                    <option value="GHS">GHS - Ghanaian Cedi</option>
                                    <option value="MAD">MAD - Moroccan Dirham</option>
                                    <option value="TND">TND - Tunisian Dinar</option>
                                    <option value="DZD">DZD - Algerian Dinar</option>
                                    <option value="XOF">XOF - West African CFA Franc</option>
                                    <option value="XAF">XAF - Central African CFA Franc</option>
                                </select>
                            </div>

                            <div className="form-group form-group-half">
                                <input 
                                    type="text" 
                                    name="site_timezone" 
                                    className="form-control"
                                    value={settings.site_timezone || 'UTC'} 
                                    placeholder="Timezone (e.g., UTC, EST)" 
                                    onChange={handleChange} 
                                />
                            </div>

                            <div className="form-group">
                                <input 
                                    type="url" 
                                    name="site_url" 
                                    className="form-control"
                                    value={settings.site_url || ''} 
                                    placeholder="Website URL (e.g., https://example.com)" 
                                    onChange={handleChange} 
                                />
                            </div>

                            <div className="form-group">
                                <textarea 
                                    name="site_keywords" 
                                    value={settings.site_keywords || ''} 
                                    onChange={handleChange} 
                                    className="form-control"
                                    placeholder="SEO Keywords (comma separated)"
                                    rows="2"
                                ></textarea>
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SiteSettings;
